var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7469 25.9193C25.5284 26.7008 25.5284 27.967 24.7469 28.7472C23.9655 29.5286 22.6993 29.5286 21.9191 28.7472C21.1376 27.9657 21.1376 26.6995 21.9191 25.9193C22.7005 25.1379 23.9667 25.1379 24.7469 25.9193Z",
    stroke: "#15222F",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0807 25.9189C10.8622 26.7005 10.8622 27.9668 10.0807 28.7471C9.29912 29.5286 8.03276 29.5286 7.25249 28.7471C6.47221 27.9656 6.47095 26.6992 7.25249 25.9189C8.03402 25.1387 9.29912 25.1374 10.0807 25.9189Z",
    stroke: "#15222F",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66669 7.99992C2.66669 6.52716 3.86059 5.33325 5.33335 5.33325H17.3334C18.8061 5.33325 20 6.52716 20 7.99992V17.3333C20 18.806 18.8061 19.9999 17.3334 19.9999H2.66669V7.99992Z",
    stroke: "#15222F",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 27.2213H4.00002C3.26402 27.2213 2.66669 26.624 2.66669 25.888V16",
    stroke: "#15222F",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.33325H25.764C26.3093 9.33325 26.8 9.66525 27.0013 10.1719L29.1427 15.5239C29.268 15.8386 29.3333 16.1746 29.3333 16.5133V25.7773C29.3333 26.5133 28.736 27.1106 28 27.1106H25.5587",
    stroke: "#15222F",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 27.2266H10.8933",
    stroke: "#15222F",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 18.6667H25.3333V14.6667H28",
    stroke: "#15222F",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/deliveryTruck.5d9a0b4b.svg";
export { ForwardRef as ReactComponent };